import { useDefaultSubscription } from '../services/useDefaultSubscription'

export default function () {
  const { subscriptionDetail } = useDefaultSubscription()
  if (!subscriptionDetail?.is_partner_customer) {
    return true
  }
  return subscriptionDetail?.company?.partner?.handles_kyc === false
}
